import { createContext, useContext } from "react";
import { Scope } from "../types";

export const ScopeContext = createContext<Scope>(null!);

export const useScopeContext = () => useContext(ScopeContext);
